import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import { paymentReport } from "../../../core/data/json/paymentReport";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { formatDate } from "../../../core/utils/FormatData";
import { fetchAllAssets } from "../../../core/data/redux/asset/asset/assetActions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import {
  fetchAllTrainingReport,
  fetchAllTrainingReportMonthly,
  fetchAllUpcomingEvents,
  fetchAllDuration,
} from "../../../core/data/redux/reports/training_report/trainingreport.Action";
import { fetchAlltraininglist } from "../../../core/data/redux/training/trainingAction";

interface TrainingReportProps {
  status?: "active" | "inactive";
  showOnlyTable?: boolean; 
} 
const TrainingReport: React.FC<TrainingReportProps> = ({ status, showOnlyTable}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [tableKey, setTableKey] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState(status || "active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedYear, setSelectedYear] = useState("2025");
  const [count, setcount] = useState<any>();
  const [monthlycost, setmonthlycost] = useState<any>();
  const [comingtraining, setupcomingtraining] = useState<any[]>([]);
  const [totalduration, settotalduration] = useState<any>();
  const { Training } = useSelector((state: any) => state.training.training);

  const data = Training ? Training : [];

  const filteredData = useMemo(() => {
    return filterData(
      data || [],
      { Status: selectedStatus },
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [dispatch, Training, selectedSort, selectedStatus]);

  function filterTrainingData(data: any[]) {
    return data.map((t) => {
      const mapped = {
        Id: t.Id || "N/A",
        Name: t.Name || "N/A",
        TrainingTypeName: t.Trainingtypename || "N/A",
        TrainerName: t.Trainername || "N/A",
        StartDate: t.StartDate || "N/A",
        EndDate: t.EndDate || "N/A",
        Description: t.Description || "N/A",
        Cost: t.Cost != null ? t.Cost : "N/A",
        Status: t.Status || "N/A",
        Location: t.Location || "N/A",
        Mode: t.Mode || "N/A",
        TotalDuration: t.TotalDuration || "N/A",
        AttendeeNames: t.AttendeeNames || "N/A"
      };

      (Object.keys(mapped) as Array<keyof typeof mapped>).forEach((key) => {
        const value = mapped[key];
        if (
          typeof value === "string" &&
          (/^\d+$/.test(value) || /^\[\d+(,\d+)*\]$/.test(value))
        ) {
          mapped[key] = "N/A";
        }
      });

      return mapped;
    });
  }

  const data2 = filterTrainingData(data)


  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, Training, selectedSort, selectedStatus]);

  const columns = [
    {
      title: "Training",
      dataIndex: "Name",
      render: (text: any) => text || "None",
      sorter: (a: any, b: any) => {
        const aType = a.Name || "";
        const bType = b.Name || "";
        return aType.length - bType.length;
      },
    },
    {
      title: "Trainer",
      dataIndex: "Trainername",
      render: (text: any) => text || "None",
      sorter: (a: any, b: any) => {
        const aType = a.Trainername || "";
        const bType = b.Trainername || "";
        return aType.length - bType.length;
      },
    },
    {
      title: "Training Type",
      dataIndex: "Trainingtypename",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          {/* <Link to="#" className="avatar avatar-md border avatar-rounded">
             <ImageWithBasePath
               src={`assets/img/users/${record.Image}`}
               className="img-fluid"
               alt="img"
             />
           </Link> */}
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{text}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.Trainingtypename.length - b.Trainingtypename.length,
    },
    {
      title: "Employee",
      dataIndex: "Employee",
      render: (_text: string, record: any) => {
        // Safely parse attendees
        let attendees: number[] = [];
        try {
          attendees = JSON.parse(record.Attendees || "[]");
        } catch {
          attendees = [];
        }

        // Split and clean image URLs
        const pictureUrls = record.AttendeePictures
          ? record.AttendeePictures.split(",")
            .map((url: string) => url.trim())
            .filter((url: string) => url !== "" && url !== "null" && url !== "undefined")
          : [];

        // Split and clean attendee names
        const attendeeNames = record.AttendeeNames
          ? record.AttendeeNames.split(",").map((n: string) => n.trim())
          : [];

        // Default profile image (local or hosted)
        const defaultProfile =
          "https://cdn-icons-png.flaticon.com/512/847/847969.png"; 

        return (
          <div className="d-flex align-items-center flex-wrap">
            {pictureUrls.length > 0 ? (
              pictureUrls.map((url: string, index: number) => (
                <img
                  key={index}
                  src={url || defaultProfile}
                  onError={(e) => ((e.currentTarget.src = defaultProfile))}
                  alt={`Attendee ${index + 1}`}
                  className="rounded-circle border me-1 mb-1"
                  style={{
                    width: "32px",
                    height: "32px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  title={`Employee: ${attendeeNames[index] || `Employee ${index + 1}`
                    }`}
                />
              ))
            ) : (
              <div className="d-flex align-items-center">
                <img
                  src={defaultProfile}
                  alt="No Attendees"
                  className="rounded-circle border me-1"
                  style={{ width: "32px", height: "32px", objectFit: "cover" }}
                />
                <span className="text-muted small">No Attendees</span>
              </div>
            )}
          </div>
        );
      },
      sorter: (a: any, b: any) => {
        const aCount = JSON.parse(a.Attendees || "[]").length;
        const bCount = JSON.parse(b.Attendees || "[]").length;
        return aCount - bCount;
      },
    }
    ,
    {
      title: "Time Duration",
      dataIndex: "TotalDuration",
      sorter: (a: any, b: any) =>
        a.TotalDuration.length - b.TotalDuration.length,
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a: any, b: any) => a.Description.length - b.Description.length,
    },
    {
      title: "Cost",
      dataIndex: "Cost",
      sorter: (a: any, b: any) => a.Cost.length - b.Cost.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => {
        const badgeClass =
          text.toLowerCase() === "active"
            ? "badge-success"
            : text.toLowerCase() === "inactive"
              ? "badge-danger"
              : "badge-secondary";
        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
        );
      },
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
  ];

  useEffect(() => {
    dispatch(fetchAlltraininglist());
    dispatch(fetchAllTrainingReport()).then((res) => {
      setcount(res.payload.data);
    });
    dispatch(fetchAllTrainingReportMonthly(selectedYear)).then((res) => {
      setmonthlycost(res.payload.data);
    });
    dispatch(fetchAllUpcomingEvents()).then((res) => {
      setupcomingtraining(res.payload.data);
    });
    dispatch(fetchAllDuration(selectedYear)).then((res) => {
      settotalduration(res.payload.data);
    });
  }, []);

  useEffect(() => {
    if (monthlycost && monthlycost.length === 12) {
      const monthlyCosts = monthlycost.map(
        (item: any) => parseFloat(item.total_training_cost) || 0
      );

      const maxValue = Math.max(...monthlyCosts);
      const yAxisMax = Math.ceil(maxValue / 1000) * 1000 || 1000;

      setmaintenancechart((prev: any) => ({
        ...prev,
        series: [
          {
            ...prev.series[0],
            data: monthlyCosts,
          },
        ],
        yaxis: {
          ...prev.yaxis,
          max: yAxisMax,
          tickAmount: 5,
          labels: {
            offsetX: -15,
            formatter: (val: number) => {
              if (val >= 100000) return (val / 100000).toFixed(1) + "L";
              if (val >= 1000) return (val / 1000).toFixed(1) + "K";
              return val;
            },
          },
        },
      }));
    }
  }, [monthlycost]);

  useEffect(() => {
    if (totalduration && totalduration.length === 12) {
      const monthlyDurations = totalduration.map(
        (item: any) => parseFloat(item.total_training_hours) || 0
      );

      const maxValue = Math.max(...monthlyDurations);
      const yAxisMax = Math.ceil(maxValue / 10) * 10 || 10;

      setsurationchart((prev: any) => ({
        ...prev,
        series: [
          {
            ...prev.series[0],
            data: monthlyDurations,
          },
        ],
        yaxis: {
          ...prev.yaxis,
          max: yAxisMax,
          tickAmount: 5,
          labels: {
            offsetX: -15,
            formatter: (val: number) => {
              if (val >= 1000) return (val / 1000).toFixed(1) + "K";
              return val;
            },
          },
        },
      }));
    }
  }, [totalduration]);

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllTrainingReportMonthly(selectedYear)).then((res) => {
        setmonthlycost(res.payload.data);
      });
      dispatch(fetchAllDuration(selectedYear)).then((res) => {
        settotalduration(res.payload.data);
      });
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  const [maintenancechart, setmaintenancechart] = useState<any>({
    series: [
      {
        name: "Training Costs",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      height: 190,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#FF9F43"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "",
      align: "left",
    },
    // grid: {
    //   row: {
    //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
    //     opacity: 0.5
    //   },
    // },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      min: 0,
      max: 65000,
      tickAmount: 5,
      labels: {
        offsetX: -15,
        formatter: (val: number) => {
          return val / 1 + "K";
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });
  const [durationchart, setsurationchart] = useState<any>({
    series: [
      {
        name: "Training Duration",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      height: 190,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#FF9F43"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "",
      align: "left",
    },
    // grid: {
    //   row: {
    //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
    //     opacity: 0.5
    //   },
    // },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      min: 0,
      max: 65000,
      tickAmount: 5,
      labels: {
        offsetX: -15,
        formatter: (val: number) => {
          return val / 1 + "Hrs";
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });
if (showOnlyTable) {
  return (
   <Table
      key={tableKey}
      dataSource={filteredData}
      columns={columns}
      Selection={true}
    />
  );
}

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Training Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Training
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Training_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Training_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 d-flex flex-wrap">
              <div className="col-lg-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body ">
                    <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                      <div className="d-flex align-items-center flex-column overflow-hidden">
                        <div>
                          <div>
                            <span className="fs-14 fw-normal text-truncate mb-1">
                              All Training Events
                            </span>
                            <h5>{count?.[0].AllTraining}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <Link
                          to="#"
                          className="avatar avatar-md br-5 payment-report-icon  bg-transparent-primary border border-primary"
                        >
                          <span className="text-primary">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-2"></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body ">
                    <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                      <div className="d-flex align-items-center flex-column overflow-hidden">
                        <div>
                          <div>
                            <span className="fs-14 fw-normal text-truncate mb-1">
                              Total Duration
                            </span>
                            <h5>{count?.[0].TotalDurationHours}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <Link
                          to="#"
                          className="avatar avatar-md br-5 payment-report-icon  bg-transparent-skyblue border border-skyblue"
                        >
                          <span className="text-skyblue">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-2"></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body ">
                    <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                      <div className="d-flex align-items-center flex-column overflow-hidden">
                        <div>
                          <div>
                            <span className="fs-14 fw-normal text-truncate mb-1">
                              Total Cost
                            </span>
                            <h5>{count?.[0].TotalTrainingCost}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <Link
                          to="#"
                          className="avatar avatar-md br-5 payment-report-icon  bg-transparent-danger border border-danger"
                        >
                          <span className="text-danger">
                            <i className="ti ti-currency-rupee" />
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="d-flex justify-content-center mt-2"> */}
                    {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        +20.01%
                                                    </span>{" "}
                                                    from last week
                                                </p> */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-body ">
                    <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                      <div className="d-flex align-items-center flex-column overflow-hidden">
                        <div>
                          <div>
                            <span className="fs-14 fw-normal text-truncate mb-1">
                              Training Pending
                            </span>
                            <h5>{count?.[0].PendingTrainingCount}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <Link
                          to="#"
                          className="avatar avatar-md br-5 payment-report-icon  bg-pink-transparent border border-pink"
                        >
                          <span className="text-pink">
                            <i className="ti ti-tools" />
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-2">
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-success fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        +20.01%
                                                    </span>{" "}
                                                    from last week
                                                </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ---- ROW 2: Chart ---- */}
            <div className="row mt-4">
              <div
                className="d-flex flex-nowrap"
                style={{
                  overflowX: "auto",
                  gap: "1.5rem",
                  paddingBottom: "1rem",
                  paddingInline: "1rem",
                }}
              >
                {/* First Chart */}
                <div
                  className="card"
                  style={{ minWidth: "480px", flex: "0 0 auto" }}
                >
                  <div className="card-header border-0">
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="d-inline-flex align-items-center mb-0">
                        <i
                          className="ti ti-square-filled fs-12 me-2"
                          style={{ color: "#FF9F43" }}
                        />
                        Training Cost Chart
                      </p>
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                          data-bs-toggle="dropdown"
                        >
                          {selectedYear}
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-end p-2">
                          {["2025", "2024", "2023"].map((year) => (
                            <li key={year}>
                              <Link
                                to="#"
                                className="dropdown-item rounded-1"
                                onClick={() => handleYearSelect(year)}
                              >
                                {year}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card-body pt-0">
                    <ReactApexChart
                      id="expense-analysis"
                      options={maintenancechart}
                      series={maintenancechart.series}
                      type="area"
                      height={210}
                    />
                  </div>
                </div>

                {/* Second Chart */}
                <div
                  className="card"
                  style={{ minWidth: "480px", flex: "0 0 auto" }}
                >
                  <div className="card-header border-0">
                    <div className="d-flex align-items-center">
                      <p className="d-inline-flex align-items-center mb-0">
                        <i className="ti ti-square-filled fs-12 text-success me-2" />
                        Upcoming Training
                      </p>
                    </div>
                  </div>
                  <div
                    className="card-body pt-0"
                    style={{ maxHeight: "210px", overflowY: "auto" }}
                  >
                    <ul className="timeline-list p-0 m-0">
                      {Array.isArray(comingtraining) &&
                        comingtraining.map((item, index) => {
                          const date = new Date(item.StartDate);
                          const formattedDate = `${String(
                            date.getDate()
                          ).padStart(2, "0")}/${String(
                            date.getMonth() + 1
                          ).padStart(2, "0")}/${date.getFullYear()}`;
                          return (
                            <li
                              key={index}
                              className="mb-2 p-3 rounded border d-flex flex-column bg-light shadow-sm"
                            >
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="fw-semibold">
                                  🛠️ {formattedDate}
                                </span>
                                <span className="text-primary text-capitalize">
                                  Mode : {item.Mode}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between text-muted small">
                                <span>Training Name : {item.Name}</span>
                                <span>Trainer: {item.trainer_name}</span>
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                </div>

                {/* Third Chart */}
                <div
                  className="card"
                  style={{ minWidth: "480px", flex: "0 0 auto" }}
                >
                  <div className="card-header border-0">
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="d-inline-flex align-items-center mb-0">
                        <i
                          className="ti ti-square-filled fs-12 me-2"
                          style={{ color: "#7367F0" }}
                        />
                        Training Hours
                      </p>
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                          data-bs-toggle="dropdown"
                        >
                          {selectedYear}
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-end p-2">
                          {["2025", "2024", "2023"].map((year) => (
                            <li key={year}>
                              <Link
                                to="#"
                                className="dropdown-item rounded-1"
                                onClick={() => handleYearSelect(year)}
                              >
                                {year}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card-body pt-0">
                    <ReactApexChart
                      id="attendance-chart"
                      options={durationchart}
                      series={durationchart.series}
                      type="bar"
                      height={210}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Training List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3"></div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default TrainingReport;
